jQuery(document).ready(function onDistressFolderReady($) {
    "use strict";

    var $distress_folder = $('.distress-folder');

    if($distress_folder.length === 0) {
        return;
    }

    var $select = $distress_folder.find('select');
    $select.on('change', onChange);

    var $distress_posts = $distress_folder.find('.archive-message');
    var distress_posts = [];
    for(var i = 0, l = $distress_posts.length, $post; i < l; ++i) {
        $post = $($distress_posts[i]);
        distress_posts.push({
            $el: $post,
            facilities: ("" + $post.data('facilities')).split(','),
            visible: $post.hasClass('distress-folder__message--visible')
        });
    }

    function onChange() {
        var $this = $(this);
        var value = $this.val();

        setDistressCookie(value);
        showDistressPostsWithId(value);
    }

    function setDistressCookie(id) {
        var now = new Date();
        var expires = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 30);
        var expires = expires.toUTCString();
        document.cookie = [
            "_distress_facility=" + id, // Cookie value,
            "expires=" + expires, // Cookie expiry date
            "path=/" // Cookie path
        ].join('; ');
    }

    function showDistressPostsWithId(id) {
        for(var i = 0, l = distress_posts.length, post; i < l; ++i) {
            post = distress_posts[i];

            if(post.facilities.indexOf(id) > -1) {
                if(!post.visible) {
                    post.visible = true;
                    post.$el.addClass('distress-folder__message--visible');
                }
            } else {
                if(post.visible) {
                    post.visible = false;
                    post.$el.removeClass('distress-folder__message--visible');
                }
            }
        }
    }
});
